// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "compiled-css" + "." + "bafe2166cd87f5c4" + ".css"
}